import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		imageItem: {
			width: '100%',
			height: '100%',
			display: 'flex',
			justifyContent: 'center',
			position: 'relative'
		},
		imageItemPortrait: {
			[theme.breakpoints.down('sm')]: {
				objectFit: 'contain'
			}
		},
		loader: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			zIndex: 0
		},
		linearOverlay: {
			position: 'absolute',
			width: '100%',
			height: '100%',
			background: 'linear-gradient(202.42deg, rgba(0, 0, 0, 0.12) -0.5%, rgba(0, 0, 0, 0) 24.05%)',
			zIndex: 2
		}
	};
});
